import React from 'react'
import { Pagination } from '@material-ui/lab'

const PaginationWrapper = ({ ...overrides }) => {
  const paginationConfig = {
    color: 'secondary',
    shape: 'rounded',
    size: 'small',
    showFirstButton: false,
    showLastButton: false,
    variant: 'outlined',
    ...overrides,
  }

  const count = paginationConfig.totalItems
  const currentPage = paginationConfig.currentPage

  if (count > 5) {
    paginationConfig.showFirstButton = true
    paginationConfig.showLastButton = true
  }

  return <Pagination count={count} page={currentPage} {...paginationConfig} />
}

export default PaginationWrapper
